export enum PaymentFailureType {
  PRM_FAILURE_RUECKERSTATTUNG_ERFOLGT = 'PRM_FAILURE_RUECKERSTATTUNG_ERFOLGT',
  NEXI_FAILURE_BEZAHLUNG_ABGEBROCHEN = 'NEXI_FAILURE_BEZAHLUNG_ABGEBROCHEN',
  NEXI_FAILURE_RUECKERSTATTUNG_FUER_TRANSAKTION_BEREITS_VERANLASST = 'NEXI_FAILURE_RUECKERSTATTUNG_FUER_TRANSAKTION_BEREITS_VERANLASST',
  TICKETDETAILS_NICHT_LADBAR_NACH_ERFOLGREICHER_ZAHLUNG = 'TICKETDETAILS_NICHT_LADBAR_NACH_ERFOLGREICHER_ZAHLUNG',
}
